import ChatSessionReplay from 'modules/chat-session-replay'

export default class LayoutChatSessionReplay {
  constructor(element, options) {
    this.chatSessionReplay = new ChatSessionReplay(element, options)
  }
}
